import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c2a42dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = { class: "rounded p-0 bg-light mt-10 px-10 mb-5" }
const _hoisted_14 = { class: "d-flex flex-row-fluid align-items-center" }
const _hoisted_15 = { class: "flex-grow-1 me-2 fw-bolder text-muted" }
const _hoisted_16 = { class: "my-2 ms-5 fw-bolder text-muted" }
const _hoisted_17 = { class: "ms-15" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-content-center mt-15"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "svg-icon svg-icon-1" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "d-flex flex-row-fluid align-items-center" }
const _hoisted_24 = { class: "flex-grow-1 me-2" }
const _hoisted_25 = {
  href: "#",
  class: "text-gray-800 fw-bolder text-hover-primary fs-6"
}
const _hoisted_26 = { class: "text-muted fw-bold d-block pt-1" }
const _hoisted_27 = { class: "d-flex" }
const _hoisted_28 = { class: "badge-light badge fs-8 fw-bolder my-2 ms-5" }
const _hoisted_29 = { class: "badge-light badge fs-8 fw-bolder p-4 my-2 ms-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t("student.studentList")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t("student.numberStudent", { nb: _ctx.studentsData.length })), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-solid ps-4 w-200px mx-2 fw-bolder text-muted",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchItems())),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClass) = $event))
        }, [
          _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.t("course.allClassrooms")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classRooms, (item, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: item._id
            }, _toDisplayString(item.name), 9, _hoisted_8))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedClass]
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchItems())),
            class: "form-control form-control-solid w-200px ps-15",
            placeholder: _ctx.t('student.findStudent')
          }, null, 40, _hoisted_11), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("course.students")), 1),
          _createElementVNode("span", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t("classList.class")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.t("classList.action")), 1)
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.studentsData, (item, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: index + 100,
          class: "d-flex align-items-sm-center rounded p-4 student-item",
          to: `/student/${item._id}/overview`
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass([`svg-icon-${item.color}`, "svg-icon me-5"])
            }, [
              _createElementVNode("span", _hoisted_21, [
                (item.photo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "w-40px",
                      src: _ctx.apiUrl + item.photo
                    }, null, 8, _hoisted_22))
                  : (_openBlock(), _createBlock(_component_el_avatar, {
                      key: 1,
                      shape: "circle",
                      size: 40,
                      style: _normalizeStyle({
                  backgroundColor:
                    item.gender == 'male'
                      ? 'var(--bs-primary)'
                      : 'var(--bs-pink)',
                })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.firstName[0].toUpperCase()) + _toDisplayString(item.lastName[0].toUpperCase()), 1)
                      ]),
                      _: 2
                    }, 1032, ["style"]))
              ])
            ], 2),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", _hoisted_25, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.moment(item.BirthDate).format("DD/MM/YYYY")), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(item.classRoomName), 1)
              ]),
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.t("course.details")), 1)
            ])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}